import { stableSort, getComparator } from '../index';

export function getVisibleRows(page: number, rowsPerPage: number, tcns: any, pagination: any) {
    const { order, orderBy } = pagination

    return stableSort(tcns, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
    )
}